import { FC } from "react";
import { IconPropsType } from ".";

export const Mail: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="transparent"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.75 5.22684C3.75 5.01113 4.00487 4.89668 4.16609 5.03999L10.8374 10.97C11.5004 11.5594 12.4996 11.5594 13.1626 10.97L19.8339 5.03999C19.9951 4.89668 20.25 5.01113 20.25 5.22684V9V12V16C20.25 18.3472 18.3472 20.25 16 20.25H8C5.65279 20.25 3.75 18.3472 3.75 16V12V9V5.22684Z"
        stroke="#C2C2C2"
        strokeWidth="1.5"
      />
      <path
        d="M7 4H17"
        stroke="#C2C2C2"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
